var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarstyle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58964 5.1102L8.73964 0.760203C9.32964 0.150203 10.3096 0.0702035 10.9596 0.630204C11.2796 0.910204 11.6096 1.6402 11.8296 2.0402C12.0496 2.4402 13.1996 4.9402 13.3996 5.0302L17.9196 5.6302C18.9196 5.8902 19.3796 7.0102 18.8996 7.9202L15.5296 11.4302L16.3696 15.9302C16.3696 17.0302 15.4796 17.7602 14.3896 17.5402L10.1096 15.4702L5.99964 17.6602C4.99964 18.0202 3.88964 17.1702 3.89964 16.1202C3.91964 14.8302 4.52964 13.1302 4.57964 11.8002C4.57964 11.7002 4.59964 11.6002 4.56964 11.5102L1.24964 8.3602C0.629641 7.4902 0.929641 6.3002 1.93964 5.9102L6.59964 5.1102H6.58964Z",
    fill: "#FFCE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarstyle);
export default __webpack_public_path__ + "static/media/starstyle.9907aa6b84bb2ae0126656ac7cb3d174.svg";
export { ForwardRef as ReactComponent };